// Compute-credit display resolution (H15).
//
// Provisioning does not write computeCredits/computeCreditLimit — only the seed
// script does. Missing fields therefore mean "credits not tracked for this org",
// and the Billing UI must not show a balance meter or a low/depleted banner
// (previously `?? 0` rendered a red "Compute credits depleted" banner to every
// newly provisioned customer on day one). Billing is invoice-based; the credit
// meter is informational and only meaningful when the fields actually exist.

export function resolveCreditsDisplay(org) {
  const hasByoc = !!org?.byocProvider;
  const tracked = org?.computeCredits !== undefined && org?.computeCreditLimit !== undefined;
  if (!tracked) {
    return { tracked, hasByoc, credits: null, creditLimit: null, creditPct: null, creditsLow: false, creditsDepleted: false };
  }
  const credits = org.computeCredits ?? 0;
  const creditLimit = org.computeCreditLimit ?? 0;
  const creditPct = creditLimit > 0 ? Math.round((credits / creditLimit) * 100) : 0;
  return {
    tracked,
    hasByoc,
    credits,
    creditLimit,
    creditPct,
    creditsLow: creditPct <= 20 && !hasByoc,
    creditsDepleted: credits <= 0 && !hasByoc,
  };
}
